<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box configuracion">
  <h3>{{ title }}</h3>
  <hr />
  <form [formGroup]="form" (submit)="nuevaTipoRevision()">
    <div class="row mb-3">
      <div class="col-12 d-flex">
        <div class="form-group w-50">          
          <label>Nuevo tipo de revisión:</label>
          <input
            type="text"
            class="form-control"
            id="nombreRevision"
            name="nombreRevision"
            formControlName="nombreRevision"
            placeholder="Ingresa el nombre del tipo de revisión"
            maxlength="128"
          />
        </div>
        <button
          [disabled]="form.invalid || btnSaveRevision"
          type="submit"
          class="btn btn-primary save btn-new-revision"
        >
          guardar
        </button>
      </div>
    </div>
  </form>
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table
          id="tblCheclist"
          datatable="ng"
          class="table table-bordered table-hover"
          [class.table-striped]="listTipoRevisiones"
        >
          <thead>
            <tr>
              <th scope="col">Folio</th>
              <th scope="col">Descripcion</th>
              <th scope="col" class="estatus text-center">
                Estatus (Activo / Inactivo)
              </th>
              <th scope="col" class="text-center">Editar</th>
              <th scope="col" class="text-center">Eliminar</th>
              <th scope="col" class="text-center">Checklists</th>
            </tr>
          </thead>
          <tbody *ngIf="listTipoRevisiones; else loading">
            <tr *ngFor="let item of listTipoRevisiones">
              <td>{{ item.IdTipoRevision }}</td>
              <td>{{ item.Descripcion }}</td>
              <td>
                <ul class="tg-list">
                  <li class="tg-list-item">
                    <input
                      (click)="estatusClick(item)"
                      bind-checked="item.IdEstatus"
                      class="tgl tgl-ios"
                      id="cb{{ item.IdTipoRevision }}"
                      type="checkbox"
                    />
                    <label
                      class="tgl-btn"
                      for="cb{{ item.IdTipoRevision }}"
                    ></label>
                  </li>
                </ul>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-primary rounded-circle"
                  (click)="editClick(item)"
                  data-bs-toggle="modal"
                  data-bs-target="#modalEdit"
                >
                  <i class="fa fa-pencil"></i>
                </button>
              </td>

              <td class="text-center">
                <button
                  class="btn btn-sm btn-danger rounded-circle"
                  (click)="deleteClick(item.IdTipoRevision)"
                  data-tooggle="modal"
                  data-target="#modalEdit-2"
                >
                  <i class="fa fa-minus"></i>
                </button>
              </td>

              <td class="text-center">
                <button
                  style="border-radius: 100%"
                  type="button"
                  class="btn btn-sm btn-primary"
                  (click)="checklistClick(item.IdTipoRevision)"
                >
                  <i class="fa fa-list"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <ng-template #loading>
            <tbody>
              <tr *ngFor="let item of [].constructor(6)">
                <td colspan="3">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
                <td colspan="3">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </div>
  </div>

  <!--------------- MODAL EDITAR --------------->
  <div
    class="modal fade"
    id="modalEdit"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalEditLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title" id="modalEditLabel">Editar revisión</h2>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form id="frmEdit" (submit)="frmEdit($event)" ngNativeValidate>
          <div class="modal-body">
            <div class="form-group">
              <label>Tipo de revisión:</label>
              <input
                type="text"
                class="form-control"
                id="textEdit"
                placeholder=""
                maxlength="128"
                required
              />
            </div>
            <label>Estatus (Activo / Inactivo)</label>
            <ul class="tg-list" class="text-left">
              <li class="tg-list-item">
                <input class="tgl tgl-ios" id="cbEdit" type="checkbox" />
                <label class="tgl-btn" for="cbEdit"></label>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary save">guardar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
